import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as IconM from '@material-ui/icons';
import { Grid, Paper } from '@material-ui/core';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import { actions } from '../../../redux/ducks/TeacherDucks';
// eslint-disable-next-line max-len
import ContainerBreadcrumbs from '../../../components/ContainerBreadcrumbs/ContainerBreadcrumbs';
import { handleReadFile } from '../../../helpers/excel-to-json';
import { RootState } from '../../../redux/store';
import ItemListData from '../../../components/ItemListData/ItemListData';
// eslint-disable-next-line max-len
import IntegrationUpload from '../../../components/IntegrationUpload/IntegrationUpload';
import { ITeacher } from '../../../interfaces/ITeacher';
import Card from '../../../components/Card/Card';

const StudentUploadBatch = (): JSX.Element => {
  const dispatch = useDispatch();

  const { loading, uploadSuccess } = useSelector((
    state: RootState,
  ) => state.teacher );
  const [listUpload, setListUpload] = useState<ITeacher[]>([]);

  const handleUpload = (): void => {
    if ( listUpload.length > 0 ) {
      dispatch( actions.createTeachersBatchThunk( listUpload ));
    }
  };

  const handleSetFile = async ( file: File ): Promise<any> => {
    const data = await handleReadFile( file, 'docentes' );
    setListUpload( data );
  };

  useEffect(() => {
    if ( listUpload.length > 0 ) {
      setListUpload([]);
    }
  }, [loading]);

  useEffect(() => {
    if ( uploadSuccess ) {
      dispatch( actions.changeStatusSuccessButton( false ));
    }
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <ContainerBreadcrumbs>
            <Breadcrumbs
              itemsLinks={[{ name: 'Docentes', url: 'admin/docentes' }]}
              itemsText={['Carga masiva']}
            />
          </ContainerBreadcrumbs>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <IntegrationUpload
            handleSetFile={handleSetFile}
            loading={loading}
            handleUpload={handleUpload}
            uploadSuccess={uploadSuccess}
          />
          <Paper>
            <ItemListData data={listUpload} iconItem={<IconM.PersonAdd />} />
          </Paper>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StudentUploadBatch;
